import axios from "axios";

export const getTelecallerFieldAgents = async (token) => {
  try {
    const response = await axios.get("telecaller/field-agents-list/", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },                                                                                                                                                
    });
    return response.data?.data;
  } catch (error) {

    return error;
  }
};
export const getTelecallerActionCodes = async (token) => {
  try {
    const response = await axios.get("telecaller/action-codes/", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },                                                                                                                                                
    });
    return response.data?.data;
  } catch (error) {

    return error;
  }
};

export const createTelecallerFeedback = async (payload, token) => {
  try {
    const finalPayload = {
      ...payload,
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      "telecaller/feedback/create/",
      finalPayload,
      config
    );

    return response;
  } catch (error) {
  return error?.response?.data;
  }
};